// extracted by mini-css-extract-plugin
module.exports = {"hidden":"header_hidden__2OhLK","fl":"header_fl__1AWvW","fr":"header_fr__1J9Pm","wrapper":"header_wrapper__1Q9I9"};